import { ArrowRightIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NotificationBanner = ({
  title,
  description,
  routeToPath,
  storeKey,
  disableLocalStorage = false,
}: {
  title?: string;
  description: string;
  routeToPath: string;
  storeKey: string;
  disableLocalStorage?: boolean;
}) => {
  const navigate = useNavigate();
  const [hideNotificationBanner, setHideNotificationBanner] = useState(() => {
    return disableLocalStorage ? false : JSON.parse(localStorage.getItem(storeKey) || 'false');
  });

  useEffect(() => {
    if (!hideNotificationBanner) {
      document.body.style.paddingTop = '48px';
      document.querySelector('.sidebar-container')?.classList.add('mt-12');
    } else {
      document.body.style.paddingTop = '0px';
      document.querySelector('.sidebar-container')?.classList.remove('mt-12');
    }

    return () => {
      document.body.style.paddingTop = '0px';
      document.querySelector('.sidebar-container')?.classList.remove('mt-12');
    };
  }, [hideNotificationBanner]);

  if (hideNotificationBanner) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 w-full bg-indigo-700 border-b border-teal-200/60 p-4 py-[10px] z-50">
      <XMarkIcon
        className="w-5 h-5 text-white absolute top-3 right-4 cursor-pointer"
        onClick={() => {
          setHideNotificationBanner(true);
          localStorage.setItem(storeKey, JSON.stringify(true));
        }}
      />

      <div className="w-full text-center">
        <h3 className="text-sm lg:text-base font-medium text-white flex items-center justify-center gap-2 tracking-normal">
          {title && <span>{title}: </span>}
          <span className="font-normal">{description}</span>
          <button
            onClick={() => {
              navigate(routeToPath);
              localStorage.setItem(storeKey, JSON.stringify(true));
            }}
            className="text-sm font-medium text-white underline hover:text-teal-100 transform -rotate-45"
          >
            <ArrowRightIcon className="w-5 h-5 ml-1" />
          </button>
        </h3>
      </div>
    </div>
  );
};

export default NotificationBanner;
